import {http} from '../core/http';
import {directoryService} from './directory';
import type {CreateFolderParams, DeleteFolderParams, RenameParams} from '../types/directory';

export const organizationService = {
  getTree() {
    return directoryService.getNavigationDirectory();
  },

  createMainDirectory(params: { name: string }) {
    return http.post('/uss/create_main_directory', params);
  },

  createChildDirectory(params: CreateFolderParams) {
    return directoryService.create(params);
  },

  rename(params: RenameParams) {
    return directoryService.rename(params);
  },

  delete(params: { item: DeleteFolderParams[] }) {
    return directoryService.delete(params);
  },
};